import { Camera } from "lucide-react";

export default function ImageSlot({
    src,
    alt,
    ratio = "aspect-[4/3]",
    arch = false,
    placeholder = false,
    className = "",
    testid,
}) {
    return (
        <figure
            data-testid={testid}
            className={`group relative overflow-hidden bg-ice ${ratio} ${
                arch ? "rounded-t-[999px] rounded-b-3xl" : "rounded-3xl"
            } ${className}`}
        >
            <img
                src={src}
                alt={alt}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(0.215,0.61,0.355,1)] group-hover:scale-[1.05]"
            />
            {placeholder && (
                <figcaption className="absolute bottom-4 right-4 flex items-center gap-2 rounded-full bg-white/85 px-4 py-2 text-[0.68rem] font-light uppercase tracking-[0.18em] text-body backdrop-blur-md">
                    <Camera className="h-3.5 w-3.5 text-petrol" />
                    Foto dello studio in arrivo
                </figcaption>
            )}
        </figure>
    );
}
